/* ============================================================
   JMO Quote — localStorage-backed B2B quote builder
   ============================================================
   - Quote items are stored CLIENT-SIDE in localStorage under key 'jmoQuote'
   - Not connected to Shopify's cart (Shopify has no native quote concept)
   - On quote page submit, items are serialized into the contact-form message
   ============================================================ */
(function () {
  if (window.__jmoQuoteInit) return;
  window.__jmoQuoteInit = true;

  var STORAGE_KEY = 'jmoQuote';

  function load() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { items: [] };
      var parsed = JSON.parse(raw);
      return parsed && Array.isArray(parsed.items) ? parsed : { items: [] };
    } catch (e) {
      return { items: [] };
    }
  }

  function save(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    notify();
  }

  function notify() {
    document.dispatchEvent(new CustomEvent('jmo:quote:change', { detail: load() }));
  }

  var Quote = {
    state: function () { return load(); },
    count: function () { return load().items.length; },
    totalQty: function () { return load().items.reduce(function (s, i) { return s + (i.qty || 1); }, 0); },
    add: function (item) {
      var state = load();
      var existing = state.items.findIndex(function (i) { return i.variantId === item.variantId; });
      if (existing >= 0) {
        state.items[existing].qty = (state.items[existing].qty || 1) + (item.qty || 1);
      } else {
        state.items.push(Object.assign({ qty: 1 }, item));
      }
      save(state);
    },
    setQty: function (variantId, qty) {
      var state = load();
      var idx = state.items.findIndex(function (i) { return i.variantId === variantId; });
      if (idx < 0) return;
      if (qty < 1) state.items.splice(idx, 1);
      else state.items[idx].qty = qty;
      save(state);
    },
    remove: function (variantId) {
      var state = load();
      state.items = state.items.filter(function (i) { return i.variantId !== variantId; });
      save(state);
    },
    clear: function () { save({ items: [] }); }
  };

  window.JmoQuote = Quote;
  // Expose setStep so external callers (e.g. PDP submit handler) can advance the drawer
  // directly to the contact form when the pack is already configured.
  Object.defineProperty(Quote, 'setStep', { value: function (n) { setStep(n); } });

  /* ----------------------------------------------------------
     Header badge — show button only when count > 0, update badge text
     ---------------------------------------------------------- */
  function updateHeaderBadge() {
    var n = Quote.count();
    document.querySelectorAll('[data-jmo-quote-count]').forEach(function (el) {
      el.textContent = n;
    });
    // Hide the entire trigger button when empty (so the header icon disappears)
    document.querySelectorAll('[data-jmo-quote-trigger]').forEach(function (btn) {
      btn.toggleAttribute('hidden', n === 0);
    });
  }
  document.addEventListener('jmo:quote:change', updateHeaderBadge);
  // Sync across tabs
  window.addEventListener('storage', function (e) { if (e.key === STORAGE_KEY) notify(); });

  /* ----------------------------------------------------------
     Drawer open/close + step navigation
     ---------------------------------------------------------- */
  // Exposed below on window.JmoQuote.setStep — used by the PDP submit handler
  // to jump straight to Step 2 (contact form) when the customer already
  // configured the pack on the PDP. Avoids the redundant ADD TO QUOTE click.
  function setStep(n) {
    var drawer = document.querySelector('[data-jmo-quote-drawer]');
    if (!drawer) return;
    drawer.setAttribute('data-step', String(n));
    // Show/hide step sections
    drawer.querySelectorAll('[data-jmo-quote-step]').forEach(function (s) {
      s.toggleAttribute('hidden', s.getAttribute('data-jmo-quote-step') !== String(n));
    });
    // Drawer title stays "QUOTE REQUEST FORM" on both steps — the per-step section
    // heading ("Contact Info") now lives INSIDE the form pane on step 2, not in
    // the title bar.
    var title = drawer.querySelector('[data-jmo-quote-title]');
    if (title) title.textContent = 'QUOTE REQUEST FORM';
    // Whenever the customer (re)lands on step 2, force the form pane to be
    // visible and the success card hidden. This catches external callers like
    // the PDP submit handler that invoke `window.JmoQuote.setStep(2)` directly
    // — without this, a customer who submitted a quote, closed the success card,
    // and then triggered the PDP "Request for Quote" flow without going through
    // openDrawer() would land back on the stale success card.
    if (String(n) === '2') resetStep2ToForm();
  }
  // Reset step 2 to its default (form visible, success card hidden) so reopening
  // the drawer after a successful submission shows a fresh form ready for the
  // customer's NEXT request — instead of being stuck on the green success card.
  function resetStep2ToForm() {
    var drawer = document.querySelector('[data-jmo-quote-drawer]');
    if (!drawer) return;
    var formWrap = drawer.querySelector('[data-jmo-quote-form-wrap]');
    var successEl = drawer.querySelector('[data-jmo-quote-success]');
    var verifyingEl = drawer.querySelector('[data-jmo-quote-verifying]');
    var submitBtn = drawer.querySelector('.jmo-quote__submit');
    if (formWrap) { formWrap.hidden = false; formWrap.style.visibility = ''; }
    if (successEl) successEl.hidden = true;
    if (verifyingEl) verifyingEl.hidden = true;
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'SUBMIT QUOTE REQUEST'; }
  }
  function openDrawer() {
    var drawer = document.querySelector('[data-jmo-quote-drawer]');
    if (!drawer) return;
    // Reset BEFORE showing — so the form pane (not the success card) is what
    // the customer sees if they reopen the drawer after a prior successful submission.
    resetStep2ToForm();
    drawer.removeAttribute('hidden');
    drawer.removeAttribute('inert');
    drawer.removeAttribute('aria-hidden');
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.classList.add('jmo-no-scroll');
    setStep(1);  // Always start at step 1
    var closeBtn = drawer.querySelector('[data-jmo-quote-close]');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 100);
    renderQuoteItems();
  }
  function closeDrawer() {
    var drawer = document.querySelector('[data-jmo-quote-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('jmo-no-scroll');
    setTimeout(function () {
      drawer.setAttribute('hidden', '');
      /* WCAG 2.1.2 / 4.1.2 fix: drawer descendants (form inputs, buttons) stayed in the
         tab order even when visually closed because `display: flex` defeats the `hidden`
         attribute. `inert` removes the entire subtree from tab order and the AT tree —
         the canonical fix for "closed drawer keyboard trap" since 2022+ browser support. */
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      // Defensive reset on close too — covers the case where the customer hits
      // CLOSE on the success card (we want the next open to land on the form,
      // not the still-visible success state). openDrawer() also resets, but
      // doing it here means setStep() calls in between are clean.
      resetStep2ToForm();
    }, 300);
  }

  /* ----------------------------------------------------------
     Click dispatcher — open, close, step nav, PDP "Request for Quote"
     ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    // Close drawer (backdrop, X button, "Continue Shopping" link)
    if (e.target.closest('[data-jmo-quote-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    // Step 1 → Step 2 (Add To Quote button)
    if (e.target.closest('[data-jmo-quote-next]')) {
      e.preventDefault();
      if (Quote.count() === 0) return;  // Don't advance with empty quote
      setStep(2);
      return;
    }
    // Step 2 → Step 1 (Back button)
    if (e.target.closest('[data-jmo-quote-back]')) {
      e.preventDefault();
      setStep(1);
      return;
    }

    // Open drawer — header icon + PDP "Request for Quote" button
    var opener = e.target.closest('[data-jmo-quote-open]');
    if (!opener) return;
    e.preventDefault();

    var isPdpOpener = !!opener.closest('.jmo-pdp');

    // If on a PDP, also ADD the current variant before opening
    var variantIdInput = document.querySelector('[data-jmo-variant-id]');
    if (variantIdInput && isPdpOpener) {
      var qtyInput = document.querySelector('input[name="quantity"]');
      var variantId = parseInt(variantIdInput.value, 10);
      var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10));

      var variantsJsonEl = document.querySelector('[data-jmo-product-json]');
      var variant = null;
      if (variantsJsonEl) {
        try {
          var variants = JSON.parse(variantsJsonEl.textContent);
          variant = variants.find(function (v) { return v.id === variantId; });
        } catch (err) {}
      }
      var productTitleEl = document.querySelector('.jmo-pdp__title');
      var mainImageEl = document.querySelector('[data-jmo-main-image]');
      Quote.add({
        variantId: variantId,
        productTitle: productTitleEl ? productTitleEl.textContent.trim() : (variant && variant.name) || 'Product',
        variantTitle: variant && variant.title !== 'Default Title' ? variant.title : '',
        price: variant ? variant.price : 0,
        image: mainImageEl ? mainImageEl.getAttribute('src') : '',
        qty: qty,
        sku: (variant && variant.sku) || '',
        url: (variant && variant.url) || (location.pathname + '?variant=' + variantId)
      });
    }

    openDrawer();

    // Header quote icon: skip the "Add to quote" step and land on the contact form
    // directly. PDP openers stay on Step 1 so the customer can review their items.
    if (!isPdpOpener && Quote.count() > 0) {
      setStep(2);
    }
  });

  // Esc key closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var drawer = document.querySelector('[data-jmo-quote-drawer].is-open');
      if (drawer) closeDrawer();
    }
  });

  /* ----------------------------------------------------------
     Quote page — render line items + wire qty/remove/submit
     ---------------------------------------------------------- */
  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function renderQuoteItems() {
    var state = Quote.state();
    var isEmpty = state.items.length === 0;

    // Step 1: Table-style items list
    var list = document.querySelector('[data-jmo-quote-items]');
    var emptyState = document.querySelector('[data-jmo-quote-empty]');
    var table = document.querySelector('[data-jmo-quote-table]');
    if (list) {
      if (isEmpty) {
        list.innerHTML = '';
        if (emptyState) emptyState.hidden = false;
        if (table) table.hidden = true;
      } else {
        if (emptyState) emptyState.hidden = true;
        if (table) table.hidden = false;
        list.innerHTML = state.items.map(function (item) {
          var href = item.url ? escapeHtml(item.url) : '#';
          // Defensive escape for fields that COULD be tampered with via localStorage
          // even though they originate from trusted Shopify CDN/product data.
          var safeImage = item.image ? escapeHtml(thumbify(item.image, 96)) : '';
          var safeVariantId = escapeHtml(String(item.variantId || ''));
          var safeQty = escapeHtml(String(item.qty || 1));
          return [
            '<li class="jmo-quote__row" data-variant-id="', safeVariantId, '">',
              '<div class="jmo-quote__row-product">',
                '<a href="', href, '" class="jmo-quote__row-thumb" aria-label="View ', escapeHtml(item.productTitle), '">',
                  safeImage ? '<img src="' + safeImage + '" alt="" width="64" height="64">' : '',
                '</a>',
                '<div class="jmo-quote__row-info">',
                  '<p class="jmo-quote__row-title"><a href="', href, '" class="jmo-quote__row-title-link">', escapeHtml(item.productTitle), '</a></p>',
                  item.variantTitle ? '<p class="jmo-quote__row-meta">' + escapeHtml(item.variantTitle) + '</p>' : '',
                  item.sku ? '<p class="jmo-quote__row-meta">SKU: ' + escapeHtml(item.sku) + '</p>' : '',
                '</div>',
              '</div>',
              '<div class="jmo-quote__row-qty">',
                '<button type="button" class="jmo-quote__qty-btn" data-jmo-quote-qty-step="-1" aria-label="Decrease quantity">−</button>',
                '<input type="number" min="1" value="', safeQty, '" data-jmo-quote-qty class="jmo-quote__qty-input" aria-label="Quantity">',
                '<button type="button" class="jmo-quote__qty-btn" data-jmo-quote-qty-step="1" aria-label="Increase quantity">+</button>',
              '</div>',
              '<button type="button" class="jmo-quote__row-remove" data-jmo-quote-remove aria-label="Remove from quote">',
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>',
              '</button>',
            '</li>'
          ].join('');
        }).join('');
      }
    }

    // Step 1: Total — quote forms never show pricing, just item count
    var totalEl = document.querySelector('[data-jmo-quote-total]');
    if (totalEl) {
      var n = state.items.reduce(function (s, i) { return s + (i.qty || 1); }, 0);
      totalEl.textContent = n + ' ' + (n === 1 ? 'item' : 'items') + ' for quote';
    }

    // Step 2: Compact recap (with EDIT link, qty stepper inline, trash)
    var recap = document.querySelector('[data-jmo-quote-recap]');
    if (recap) {
      if (isEmpty) {
        recap.innerHTML = '<li class="jmo-quote__recap-empty">No items in quote.</li>';
      } else {
        recap.innerHTML = state.items.map(function (item) {
          var href = item.url ? escapeHtml(item.url) : '#';
          var safeImage = item.image ? escapeHtml(thumbify(item.image, 96)) : '';
          var safeVariantId = escapeHtml(String(item.variantId || ''));
          var safeQty = escapeHtml(String(item.qty || 1));
          return [
            '<li class="jmo-quote__recap-row" data-variant-id="', safeVariantId, '">',
              '<a href="', href, '" class="jmo-quote__row-thumb" aria-label="View ', escapeHtml(item.productTitle), '">',
                safeImage ? '<img src="' + safeImage + '" alt="" width="56" height="56">' : '',
              '</a>',
              '<div class="jmo-quote__row-info">',
                '<p class="jmo-quote__row-title"><a href="', href, '" class="jmo-quote__row-title-link">', escapeHtml(item.productTitle), '</a></p>',
                item.variantTitle ? '<p class="jmo-quote__row-meta">' + escapeHtml(item.variantTitle) + '</p>' : '',
                item.sku ? '<p class="jmo-quote__row-meta">SKU: ' + escapeHtml(item.sku) + '</p>' : '',
              '</div>',
              '<div class="jmo-quote__recap-qty">',
                '<button type="button" class="jmo-quote__qty-btn" data-jmo-quote-qty-step="-1" aria-label="Decrease quantity">−</button>',
                '<input type="number" min="1" value="', safeQty, '" data-jmo-quote-qty class="jmo-quote__qty-input" aria-label="Quantity">',
                '<button type="button" class="jmo-quote__qty-btn" data-jmo-quote-qty-step="1" aria-label="Increase quantity">+</button>',
                '<button type="button" class="jmo-quote__row-remove" data-jmo-quote-remove aria-label="Remove from quote">',
                  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>',
                  '<span class="jmo-quote__row-remove-label">Remove</span>',
                '</button>',
              '</div>',
            '</li>'
          ].join('');
        }).join('');
      }
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Thumbnail-ify a Shopify CDN image URL: force `width` and `format=webp` query params
     so the quote drawer + recap thumbnails download a ~96px WebP instead of the original
     1000-2000px PNG. Handles three cases:
     1. URL with no query string → append `?width=N&format=webp`
     2. URL with query string but no width/format → append the params
     3. URL with existing width=/format= → strip the old, append the new
     Net effect: every cart/quote thumbnail is ~5-10 KB instead of 50-100 KB. Old items
     stored in localStorage from before the WebP migration get the same treatment. */
  function thumbify(url, width) {
    if (!url) return '';
    var w = width || 96;
    var qIdx = url.indexOf('?');
    var base = qIdx === -1 ? url : url.slice(0, qIdx);
    var query = qIdx === -1 ? [] : url.slice(qIdx + 1).split('&').filter(function (p) {
      // Keep everything except width= and format= (we're overriding those)
      return p.indexOf('width=') !== 0 && p.indexOf('format=') !== 0;
    });
    query.push('width=' + w);
    query.push('format=webp');
    return base + '?' + query.join('&');
  }

  document.addEventListener('click', function (e) {
    var row = e.target.closest('.jmo-quote__row, .jmo-quote__recap-row');
    if (!row) return;
    var variantId = parseInt(row.getAttribute('data-variant-id'), 10);

    var stepBtn = e.target.closest('[data-jmo-quote-qty-step]');
    if (stepBtn) {
      var step = parseInt(stepBtn.getAttribute('data-jmo-quote-qty-step'), 10);
      var current = Quote.state().items.find(function (i) { return i.variantId === variantId; });
      if (current) Quote.setQty(variantId, (current.qty || 1) + step);
      if (Quote.count() === 0) closeDrawer();
      else renderQuoteItems();
      return;
    }

    var removeBtn = e.target.closest('[data-jmo-quote-remove]');
    if (removeBtn) {
      Quote.remove(variantId);
      if (Quote.count() === 0) closeDrawer();
      else renderQuoteItems();
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-jmo-quote-qty]');
    if (!input) return;
    var row = input.closest('.jmo-quote__row, .jmo-quote__recap-row');
    if (!row) return;
    var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
    var newQty = Math.max(1, parseInt(input.value, 10) || 1);
    Quote.setQty(variantId, newQty);
    renderQuoteItems();
  });

  /* ----------------------------------------------------------
     Quote form submission — NATIVE submit (so Shopify's reCAPTCHA
     interceptor can attach its token), then detect the success
     redirect on the next page load and show the inline success view.

     We attempted AJAX submit via fetch() but Shopify's /contact endpoint
     rejects with 400 "Missing CAPTCHA token" when the request bypasses
     the native form submission flow that auto-attaches the token. Going
     back to a native submit + post-redirect detection is the cleanest path.
     ---------------------------------------------------------- */
  function buildQuoteBody(form, items) {
    var userMessage = form.querySelector('[name="contact[user_message]"]');
    var userMessageText = userMessage ? userMessage.value.trim() : '';
    var industry = form.querySelector('[name="contact[Industry]"]');
    var company = form.querySelector('[name="contact[Company]"]');

    var lines = ['=== QUOTE REQUEST ==='];
    if (company && company.value) lines.push('Company: ' + company.value);
    if (industry && industry.value) lines.push('Industry: ' + industry.value);
    lines.push('');
    lines.push('--- ITEMS ---');
    items.forEach(function (item, idx) {
      lines.push((idx + 1) + '. ' + item.productTitle + (item.variantTitle ? ' — ' + item.variantTitle : ''));
      if (item.sku) lines.push('   SKU: ' + item.sku);
      lines.push('   Quantity: ' + (item.qty || 1));
      lines.push('');
    });
    if (userMessageText) {
      lines.push('--- CUSTOMER NOTES ---');
      lines.push(userMessageText);
    }
    return lines.join('\n');
  }

  function showQuoteInlineError(form, msg) {
    var errorEl = form.querySelector('[data-jmo-quote-ajax-error]');
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
    try { errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }

  function hideQuoteInlineError(form) {
    var errorEl = form.querySelector('[data-jmo-quote-ajax-error]');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
  }

  function swapToSuccess(drawerStep) {
    if (!drawerStep) return;
    var formWrap = drawerStep.querySelector('[data-jmo-quote-form-wrap]');
    var successEl = drawerStep.querySelector('[data-jmo-quote-success]');
    if (formWrap) formWrap.hidden = true;
    if (successEl) {
      successEl.hidden = false;
      try { successEl.setAttribute('tabindex', '-1'); successEl.focus({ preventScroll: false }); } catch (e) {}
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.jmo-quote__form');
    if (!form) return;

    var state = Quote.state();
    if (state.items.length === 0) {
      e.preventDefault();
      showQuoteInlineError(form, 'Please add at least one item before submitting a quote request.');
      return;
    }

    hideQuoteInlineError(form);

    // Populate the structured message body in the hidden contact[body] field
    var bodyInput = form.querySelector('[name="contact[body]"]');
    if (bodyInput) bodyInput.value = buildQuoteBody(form, state.items);

    // Lock submit button so the customer can't double-fire while the page reloads
    var submitBtn = form.querySelector('.jmo-quote__submit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'SENDING…';
    }

    // Show "Verifying…" overlay over the form. This covers the brief redirect
    // window so the customer sees something happening instead of an apparently-
    // frozen form. Hide the form content underneath so they can't double-edit
    // mid-submit. If the redirect never fires (network hiccup, etc.), the
    // overlay self-clears after 8s so the customer can retry.
    var drawerStep = form.closest('[data-jmo-quote-step="2"]');
    var verifyingEl = drawerStep && drawerStep.querySelector('[data-jmo-quote-verifying]');
    var formWrapEl = drawerStep && drawerStep.querySelector('[data-jmo-quote-form-wrap]');
    if (verifyingEl) verifyingEl.hidden = false;
    if (formWrapEl) formWrapEl.style.visibility = 'hidden';
    setTimeout(function () {
      // Defensive: if the page hasn't navigated within 8s, restore the form so the
      // customer can try again. In a successful flow the browser has long since
      // navigated away by this point.
      if (verifyingEl) verifyingEl.hidden = true;
      if (formWrapEl) formWrapEl.style.visibility = '';
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'SUBMIT QUOTE REQUEST'; }
    }, 8000);

    // Mark this as a QUOTE submission so the post-redirect detection can
    // distinguish it from generic /contact submissions (the contact page +
    // bulk-orders page also use {% form 'contact' %} and Shopify redirects all
    // three with the same ?contact_posted=true marker). Without this flag,
    // a customer submitting the contact page form would see the quote-drawer
    // success card pop up on their PDP next visit — clearly wrong.
    //
    // The flag is consumed (cleared) on the next page load — either honored
    // when the URL also has ?contact_posted=true (quote success), or stripped
    // as stale on any other navigation (handles abandoned-challenge cleanup).
    sessionStorage.setItem('jmoQuoteFormSubmitted', '1');

    // Hand off to native submit. Shopify's hCaptcha hook needs a native form
    // submission to attach its token. The browser POSTs → Shopify redirects to
    // /current-page?contact_posted=true on success (no-challenge fast path) or
    // routes through /challenge first then comes back.
    // No preventDefault — the browser submits the form normally.
  });

  // On page load: show the quote success card ONLY when BOTH conditions are true:
  //   1. URL has ?contact_posted=true (Shopify confirms a form submission landed)
  //   2. sessionStorage flag jmoQuoteFormSubmitted is set (proves it was OUR
  //      quote drawer that submitted, not the contact page or bulk-orders page —
  //      all three use {% form 'contact' %} and Shopify redirects all three to
  //      the same ?contact_posted=true URL)
  //
  // The flag is cleared on any page load that does NOT have contact_posted=true.
  // That handles the abandoned-challenge case: customer submits quote → flag set
  // → goes to /challenge → bails → navigates to some other JMO page → flag wiped
  // → no false success when they later submit a different form. (Without this
  // cleanup, a customer who abandons the quote challenge and then submits the
  // contact form would see the quote success card pop up — wrong.)
  function maybeShowQuoteSuccess() {
    var params = new URLSearchParams(window.location.search);

    // Customer clicked "Cancel and go back" — clear flag, strip marker from URL.
    if (params.get('jmo_quote_cancel') === '1') {
      sessionStorage.removeItem('jmoQuoteFormSubmitted');
      sessionStorage.removeItem('jmoQuoteJustSubmitted'); // legacy flag cleanup
      if (window.history && window.history.replaceState) {
        params.delete('jmo_quote_cancel');
        var cleanCancel = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        window.history.replaceState({}, '', cleanCancel);
      }
      return;
    }

    // Defensive: always wipe any legacy jmoQuoteJustSubmitted flag from older
    // code versions so it can't trigger anything.
    sessionStorage.removeItem('jmoQuoteJustSubmitted');

    // No success param → clear the quote-form flag too (handles abandonment:
    // customer submitted quote, navigated to a non-success page → flag is stale
    // and must not persist into a later contact/bulk form post).
    //
    // CRITICAL: Do NOT wipe the flag while we're sitting on the /challenge page.
    // /challenge is an intermediate step in the SUCCESS flow — Shopify routes a
    // suspicious submission through it for CAPTCHA verification, then redirects
    // back to the original page with ?contact_posted=true. The flag must survive
    // across that verification step. (Without this guard, the customer landed on
    // /challenge → maybeShowQuoteSuccess wiped the flag → they solved the CAPTCHA
    // → redirected back to PDP with success param → flag was already gone → no
    // success card. That's the bug john@jmotechnology.com reported.)
    if (params.get('contact_posted') !== 'true') {
      if (window.location.pathname.indexOf('/challenge') !== 0) {
        sessionStorage.removeItem('jmoQuoteFormSubmitted');
      }
      return;
    }

    // contact_posted=true is present — but is it OUR quote form? If no flag was
    // set, this was the contact page or bulk-orders page submitting. Bail without
    // showing the quote drawer success card.
    if (sessionStorage.getItem('jmoQuoteFormSubmitted') !== '1') {
      return;
    }

    // Confirmed quote-form submission landed. Consume the flag, wipe items,
    // and show the success card.
    sessionStorage.removeItem('jmoQuoteFormSubmitted');
    Quote.clear();
    updateHeaderBadge();

    var drawer = document.querySelector('[data-jmo-quote-drawer]');
    if (!drawer) return;

    // Open the drawer with the SAME treatment openDrawer() uses (animation + body lock),
    // but force step 2 + success view instead of starting at step 1.
    drawer.removeAttribute('hidden');
    drawer.removeAttribute('inert');
    drawer.removeAttribute('aria-hidden');
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.classList.add('jmo-no-scroll');
    setStep(2);
    var step2 = drawer.querySelector('[data-jmo-quote-step="2"]');
    if (step2) swapToSuccess(step2);

    // Clean the URL so a refresh doesn't re-trigger the success state
    if (window.history && window.history.replaceState) {
      params.delete('contact_posted');
      params.delete('form_type');
      var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.history.replaceState({}, '', clean);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderQuoteItems();
    updateHeaderBadge();
    maybeShowQuoteSuccess();
  });
  if (document.readyState !== 'loading') {
    updateHeaderBadge();
    renderQuoteItems();
  }
})();

/* ============================================================
   Color-name auto-fit
   ============================================================
   PROJECT RULE: color names must fit inside their swatch/allocator cell box at every
   viewport. Word wrapping handles the easy cases ("Cool White" → "Cool" / "White"),
   but a single long word like "Translucentmarigold" with no break point can't be
   wrapped via CSS without ellipsis or mid-word break — both forbidden by the rule.
   This script measures each name element and progressively shrinks font-size until
   its scrollWidth <= clientWidth. Runs on DOMContentLoaded + window resize.

   Floor: 9px (0.5625rem). Below that, even a single word might still not fit — we
   accept the visual clip rather than make the text completely unreadable. In practice
   that case only fires on absurd 25+ character single words; realistic color names
   (the user's "Cool White", "Translucent Orange", etc.) fit at 11-12px easily.

   Cap: the element's CSS-declared font-size (typically 12px / 0.75rem). We never
   ENLARGE the font, only shrink as needed.
*/
(function () {
  if (window.__jmoNameFitterInit) return;
  window.__jmoNameFitterInit = true;

  // Each entry is an independent visual group. Within a group, every member ends up at
  // the SAME font-size (the smallest size any one member needed to fit) so the labels
  // read as one consistent set rather than a stair-step of mismatched sizes. Add more
  // selectors here to add more independent groups.
  var GROUPS = [
    '.jmo-pdp__swatch-name',
    '.jmo-pdp-allocator__name-title'
  ];
  var FLOOR_PX = 10; // Floor never reads as too-small body text.
  var STEP_PX = 0.5;
  // Trailing breathing room (in pixels) reserved inside the column so the text's last
  // glyph never sits flush against the column edge. Composes with the CSS
  // padding-inline-end on .jmo-pdp-allocator__name-title — together they guarantee a
  // visible gap from the +/- stepper next door.
  var TRAILING_BUFFER_PX = 18;

  // Measure the ACTUAL rendered width of the text content inside `el` using a Range.
  // We cannot use el.scrollWidth here — for a block-like element with text that fits,
  // scrollWidth equals clientWidth, so we can't tell whether the text is 10px wide or
  // 150px wide just by looking at scrollWidth. Range.getBoundingClientRect on the text
  // node gives us the true glyph-box width regardless of container size.
  function measureTextWidth(el) {
    if (!el.firstChild) return 0;
    var range = document.createRange();
    range.selectNodeContents(el);
    var rect = range.getBoundingClientRect();
    range.detach && range.detach();
    return rect.width;
  }

  // Shrink `el` from `startPx` downward until its measured text width fits inside
  // (clientWidth − TRAILING_BUFFER_PX), or we hit the floor.
  // Returns the resulting size (the largest size ≤ startPx that fits). Mutates el.style.
  function findFitSize(el, startPx) {
    var available = el.clientWidth - TRAILING_BUFFER_PX;
    if (measureTextWidth(el) <= available) return startPx;
    var size = startPx;
    // Guard: don't loop forever if clientWidth is 0 (off-screen / not yet laid out).
    if (available <= 0) return startPx;
    while (size > FLOOR_PX && measureTextWidth(el) > available) {
      size -= STEP_PX;
      el.style.fontSize = size + 'px';
    }
    return size;
  }

  // Uniform-fit pattern: reset every element in the group, find the minimum size needed
  // anywhere in the group, then apply that single size to all members. The longest name
  // still fits; every other name matches it. No more visual stair-stepping between
  // "Black" at 12px and "Cool White" at 10.5px sitting side-by-side.
  function fitGroup(selector) {
    var els = document.querySelectorAll(selector);
    if (!els.length) return;

    // Pass 1: reset to CSS-declared size so we measure from a known baseline.
    var baseline = [];
    for (var i = 0; i < els.length; i++) {
      els[i].style.fontSize = '';
      var px = parseFloat(getComputedStyle(els[i]).fontSize);
      baseline.push(!px || isNaN(px) ? 12 : px);
    }

    // Pass 2: per-element find-min. Each element tells us what size IT needs to fit.
    var groupMin = baseline[0];
    for (var j = 0; j < els.length; j++) {
      var fits = findFitSize(els[j], baseline[j]);
      if (fits < groupMin) groupMin = fits;
    }

    // Pass 3: apply the group min to every member so they're visually uniform.
    for (var k = 0; k < els.length; k++) {
      els[k].style.fontSize = groupMin + 'px';
    }
  }

  function fitAll() {
    for (var g = 0; g < GROUPS.length; g++) fitGroup(GROUPS[g]);
  }

  // Initial fit. Two-pass strategy:
  //   1. Fit on DOMContentLoaded so users see SOMETHING reasonable immediately.
  //   2. Re-fit once document.fonts has finished loading. Without this, the first pass
  //      measures with the fallback (system) font — Montserrat is wider on average,
  //      so when it swaps in, previously-fitting names overflow.
  function initialFit() {
    fitAll();
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(fitAll).catch(function () { /* swallow — fitAll already ran */ });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialFit);
  } else {
    initialFit();
  }

  // Re-fit on resize (allocator cell width varies with viewport breakpoint changes)
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitAll, 150);
  });

  // Re-fit when allocator JS re-renders rows (variant selection, pack-size change)
  // The allocator emits no custom event yet, so observe its container for child changes.
  if (window.MutationObserver) {
    var alloc = document.querySelector('[data-jmo-allocator]');
    if (alloc) {
      new MutationObserver(function () { fitAll(); }).observe(alloc, { childList: true, subtree: true });
    }
  }

  // CRITICAL: the allocator starts display:none (revealed only after the user picks a
  // pack tier). When hidden, every name element has clientWidth=0 — so the fitter on
  // DOMContentLoaded measures zero-width rows and exits without changing anything. When
  // the user later reveals the allocator, no event fires to re-run the fitter, so names
  // sit at their default 14px size in cells that may only be 20px wide. ResizeObserver
  // fires on the hidden→visible transition (0 → real width counts as a resize) and on
  // every subsequent layout change too — exactly what we need.
  if (window.ResizeObserver) {
    var allocForResize = document.querySelector('[data-jmo-allocator]');
    if (allocForResize) {
      var roTimer = null;
      var ro = new ResizeObserver(function () {
        // Debounce — many resize entries can fire during a single layout change.
        if (roTimer) clearTimeout(roTimer);
        roTimer = setTimeout(fitAll, 50);
      });
      ro.observe(allocForResize);
    }
  }

  // Expose for manual re-trigger by other scripts (e.g. after AJAX section reloads).
  window.__jmoFitNames = fitAll;
})();
